import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TherapyLimitationForm } from '../../models';

/**
 * TherapyLimitationFormComponent
 */
@Component({
    selector: 'app-therapy-limitation-form',
    templateUrl: './therapy-limitation-form.component.html',
    styleUrls: ['./therapy-limitation-form.component.scss'],
})
export class TherapyLimitationFormComponent {
    /**
     * Form group
     */
    @Input() formGroup: FormGroup<TherapyLimitationForm>;

    /**
     * Is bed side mode
     */
    @Input() isBedSideMode: boolean;

    /**
     * Is form active / visible
     */
    @Input() isActive: boolean;

    /**
     * Max textarea rows count size
     */
    @Input() textareaMaxRows = 32;

    /**
     * Keyboard enter clicked
     */
    @Output() keyboardEnterClicked: EventEmitter<void> = new EventEmitter();
}
